import React from 'react'
import Section from '@components/layout/Section/Section'
import SectionHeading from '@components/layout/Section/SectionHeading/SectionHeading'
import informationContent from './content/informationContent'
import storageAndSecurity from './content/storageAndSecurity'
import cookiePolicy from './content/cookiePolicy'
import useOfYourData from './content/useOfYourData'
import TextWithHeading from '@components/layout/Section/TextWithHeading/TextWithHeading'
import { P } from '@components/typography'

const PrivacyPolicyPage = () => (
  <>
    <Section>
      <SectionHeading
        heading="Privacy Policy"
        tagline="The information we learn from customers helps us personalize and continually improve your Entrepreneur Seminar experience. Here are the types of information we gather:"
      />
      {informationContent.map(({ heading, paragraphs }) => (
        <TextWithHeading key={heading} heading={heading} paragraphs={paragraphs} />
      ))}
    </Section>

    <Section>
      <SectionHeading heading="Information Storage and Security" />
      {storageAndSecurity.map(({ heading, paragraphs }) => (
        <TextWithHeading key={heading} heading={heading} paragraphs={paragraphs} />
      ))}

      {cookiePolicy.map(({ heading, topParagraphs, bullets, bottomParagraphs }) => (
        <div key={heading}>
          <TextWithHeading heading={heading} paragraphs={topParagraphs} />
          <ul>
            {bullets.map(item => (
              <li key={item}>
                <P>{item}</P>
              </li>
            ))}
          </ul>
          <TextWithHeading paragraphs={bottomParagraphs} />
        </div>
      ))}

      {useOfYourData.map(({ heading, paragraphs }) => (
        <TextWithHeading key={heading} heading={heading} paragraphs={paragraphs} />
      ))}
    </Section>
  </>
)

export default PrivacyPolicyPage
